



































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Util, getExcelJSONDataByList, getPageAPIs } from "@/common/util";
// import { CouponsManageAPI } from "@/common/api/couponList";
import BusinessShopDistributeRecordAPI from '@/common/api/operationManage/businessShopDistributeRecord';
import { excuteDownloadExport2Excel } from "@/common/xlsx";
import { DeepLoop } from "@/common/deepLoop/deepLoop";
import ZlSelect from "@/components/third-custom-components/select";

import ZlOption from "@/components/third-custom-components/option";

import {
  shareConfirmOptions,
  getCommonList
} from '@/common/config'

export const pageApiList = getPageAPIs(BusinessShopDistributeRecordAPI)

const defaultForm = {
  shop_name: "", // 店铺名称
  shop_status: -1, // 店铺状态
  time: [], // 开业时间
  city_id: -1, // 城市
  contract_time: [], // 解约时间
}


const defaultForms = {
  id: '',
  shop_name: '', // 店铺名称
  phone: '', // 商户手机号
  shop_status: '', // 店铺状态
  start_business_time: '', // 开业时间
  over_contract_time: '', // 解约时间
  province_id: '', // 所在省份
  city_id: '', // 所在城市

  region: '', // 所在区域
  shop_address: '', // 店铺位置
  operation_manager: '', // 运营负责人
  // singleMaxCountType: '0',
  // shop_id: "",
  // maxLimitCount: ''
};

// 店铺状态:1开业中2对接中3暂停对接4已解约
const shopStatus2Ch: string[] = ['', '开业中', '对接中', '暂停对接', '已解约']

// const defaultSearchVenuePageOption = {
//   page: 1,
//   limit: 10,
//   isRearchBottom: false,
// };

const businessReminderDialogTitle2ch: any = {
  "new-business-shop-distribute-record": "新增",
  "edit-business-shop-distribute-record": "编辑",
};

// 最大有效期
// const maxExpiredDays = 9999;

// 最大时长 单位分钟
// const maxTimeDuration = 24 * 60;

const maxTotalMoney = 9999999

@Component({
  components: {
    ZlSelect,
    ZlOption,
  },
  filters: {
    showShopStatusName(shop_status: number) {
      return shopStatus2Ch[shop_status] || '未知'
    }
    // showMutipleShopNames(tipRow: any) {
    //   const {
    //     shop_name = '',
    //     assistant_shop_name = ''
    //   } = tipRow || {}

    //   const names: string[] = [shop_name, assistant_shop_name].filter((name: string) => !!name)

    //   return names.join('、')
    // }
  }
})
export default class BusinessShopDistributeRecord extends Vue {
  private form: any = {
    // storageLockerId: "",
    
    // shop_id: '',
    // time: [],
    // startDate: "",
    // endDate: "",
  };
  private forms: any = {
    // maxType: "0",
    // ...defaultForms
  };

  private chooseShopStatusList: any[] = [
    ...getCommonList(shopStatus2Ch, 1)
  ]

  private deepLoopUtil: any = {};

  // private merchantApi: any;

  private businessShopDistributeRecordApi = new BusinessShopDistributeRecordAPI();

  // private storageLockerTimeDurationAPI = new BusinessShopDistributeRecordTimeDurationManageAPI();
  constructor() {
    super();

    this.deepLoopUtil = new DeepLoop();

    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm, false),
    }

    this.forms = {
      ...this.deepLoopUtil.deepCopy(defaultForms, false),
    };

    // this.searchVenuePageOption = {
    //   ...this.deepLoopUtil.deepCopy(defaultSearchVenuePageOption, false),
    // };

    // this.merchantApi = new MerchantApi();
  }

  
  // private created(): void {
  //   this.getBusinessShopDistributeRecordList();

  //   // this.refreshBusinessShopDistributeRecordTimeDurations();

  //   // this.refreshTableClass();
  // }

  private activated() {
    this.refreshChooseAllCityList();

    this.refreshOpenBusinessProcessProviceList();

    this.getBusinessShopDistributeRecordList();
  }


  private restForm(): void {
    this.form = new Util().clearObject(this.form);

    this.getBusinessShopDistributeRecordList();
  }
  //搜索
  private search(): void {
    this.tablePage.page = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;
    this.getBusinessShopDistributeRecordList();
  }

  private tableData: any[] = [];

  //dialog
  // private dialogFormVisible: boolean = false;
  private formLabelWidth: string = "120px";
  
  private tablePage: any = {
    count: 0,
    page: 1,
    prepage: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
    totalPage: 0,
  };
  // //翻页
  private handlePageChange(val: any) {
    this.tablePage.page = val.currentPage;
    this.tablePage.prepage = val.pageSize;
    this.getBusinessShopDistributeRecordList();
  }

  private addOrUpdateBusinessShopDistributeRecordTitle: string = "加盟球房分布";

  private dialogFormVisible: boolean = false;

  // 拉起加盟球房分布弹框
  private handleWakeBusinessShopDistributeRecordDialog(mode: string) {
    // if (mode == 'new-business-shop-distribute-record') { // 新增加盟球房分布

    // }
    this.storageLockerDialogMode = mode;
    this.addOrUpdateBusinessShopDistributeRecordTitle = businessReminderDialogTitle2ch[mode] || "加盟球房分布";

    this.initBusinessShopDistributeRecordForm(mode);

    this.dialogFormVisible = true;
  }

  private currentBusinessShopDistributeRecordItem: any = null;

  private storageLockerDialogMode: string = "";

  private async initBusinessShopDistributeRecordForm(mode: string) {
    const forms: any = {
      ...this.deepLoopUtil.deepCopy(defaultForms, false),
    };

    if (mode == "edit-business-shop-distribute-record") {
      // 编辑

      // await this.refreshBusinessShopDistributeRecordTimeDurations();

      // await this.refreshTableClass();

      const currentBusinessShopDistributeRecordItem = this.currentBusinessShopDistributeRecordItem;

      const {
        id,
        shop_name = '',
        phone = '',
        shop_status = '',
        start_business_time = '',
        over_contract_time = '',
        province_id = '',
        city_id = '',
        region = '',
        shop_address = '',
        operation_manager = '',
      } = currentBusinessShopDistributeRecordItem || {};

      if (province_id) {
        await this.refreshOpenBusinessProcessCityList(province_id)
      }

      Object.assign(forms, {
        shop_name,
        phone,
        shop_status,
        start_business_time,
        over_contract_time,
        province_id,
        city_id,

        region,
        shop_address,
        operation_manager
      })

      

      // const venues: any[] = []

      // const handleAddExtraVenue = (venues: any[], id: any, name: any) => {
      //   if (name && typeof id == 'number') {
      //     let existVenue = this.venueList.find((venue) => venue.id == id);

      //     if (!existVenue) {
      //       existVenue = {
      //         id,
      //         name,
      //       };
      //       this.venueList.push(existVenue);
      //     }

      //     venues.push(existVenue)
      //   }
      // }

      // handleAddExtraVenue(venues, shop_id, shop_name)
      // handleAddExtraVenue(venues, assistant_shop_id, assistant_shop_name)

      // if (shop_name && typeof shop_id == "number") {
      //   console.log(shop_id, "shop_id");

      //   console.log(this.venueList, "this.venueList");
      //   let existVenue = this.venueList.find((venue) => venue.id == shop_id);

      //   if (!existVenue) {
      //     existVenue = {
      //       id: shop_id,
      //       name: shop_name,
      //     };
      //     this.venueList.push(existVenue);
      //   }

      //   forms.venue = existVenue;
      // }

      // forms.venues = venues;

      forms.id = id;
    }

    console.log(forms, "forms");

    // console.log(this.venueList, "this.venueList");

    this.forms = forms;
  }

  private chooseCityList: any[] = []

  private refreshChooseAllCityList() {
    return new Promise((resolve, reject) => {
      this.businessShopDistributeRecordApi.getOpenBusinessProcessCityList({
        type: 2,
      }, (res: any) => {
        const {
          data: list = []
        } = res || {}

        this.chooseCityList = list

        resolve(list)

      }, (err: any) => reject(err))
    })
  }

  private chooseOpenBusinessProviceList: any[] = []
  private refreshOpenBusinessProcessProviceList() {
    return new Promise((resolve, reject) => {
      this.businessShopDistributeRecordApi.getOpenBusinessProcessCityList({
        type: 1,
      }, (res: any) => {
        const {
          data: list = []
        } = res || {}

        this.chooseOpenBusinessProviceList = list

        resolve(list)

      }, (err: any) => reject(err))
    })
  }

  private onChangeFormsProvice() {
    this.$set(this.forms, 'city_id', '')
    this.refreshOpenBusinessProcessCityList() 
  }

  private chooseOpenBusinessCityList: any[] = []
  private refreshOpenBusinessProcessCityList(provinceId: any = null) {
    return new Promise((resolve, reject) => {
      const forms = this.forms || {}

      const province_id = provinceId || forms.province_id

      
      if (!province_id) {
        this.chooseOpenBusinessCityList = []
        resolve([])
      }
      this.businessShopDistributeRecordApi.getOpenBusinessProcessCityList({
        type: 2,
        parent_id: province_id
      }, (res: any) => {
        const {
          data: list = []
        } = res || {}

        this.chooseOpenBusinessCityList = list

        resolve(list)

      }, (err: any) => reject(err))
    })
  }

  private handleWakeEditBusinessShopDistributeRecordDialog(storageLockerItem: any) {
    this.currentBusinessShopDistributeRecordItem = storageLockerItem;

    this.handleWakeBusinessShopDistributeRecordDialog("edit-business-shop-distribute-record");
  }

  // private handleDelteBusinessShopDistributeRecordDialog(storageLockerItem: any) {
  //   this.$confirm("确定删除该加盟球房分布?", "", {
  //     ...shareConfirmOptions,
  //   }).then(() => {
  //     this.businessShopDistributeRecordApi.deleteBusinessShopDistributeRecord({
  //       id: storageLockerItem.id
  //     }, () => {
  //       this.getBusinessShopDistributeRecordList()
  //     }, () => {

  //     })
  //   });
  // }


  // private venueList: any[] = [
  //   // {
  //   //   id: 1,
  //   //   label: '测试'
  //   // },
  //   // {
  //   //   id: 2,
  //   //   label: '测试2'
  //   // }
  // ];

  // private searchVenueLoading: boolean = false;

  // private remoteGetVenueQueryString: string = "";

  // private remoteSearchVenueTimer: any = null;

  // private searchVenuePageOption: any = {};

  // private initRemoteGetVenuePageOption() {
  //   this.searchVenuePageOption = {
  //     ...this.deepLoopUtil.deepCopy(defaultSearchVenuePageOption, false),
  //   };
  // }

  // private getSearchVenueParams() {
  //   const searchVenuePageOption = this.searchVenuePageOption;

  //   const remoteGetVenueQueryString = this.remoteGetVenueQueryString;

  //   const { page, limit } = searchVenuePageOption;

  //   const params: any = {
  //     page,
  //     limit,
  //   };

  //   if (remoteGetVenueQueryString && remoteGetVenueQueryString.trim()) {
  //     params.name = remoteGetVenueQueryString.trim();
  //   }

  //   return params;
  // }

  // private getMoreVenueList(refresh: boolean = true) {
  //   return new Promise((resolve: Function, reject: Function) => {
  //     if (refresh) {
  //       this.initRemoteGetVenuePageOption();
  //     }

  //     const params = this.getSearchVenueParams();

  //     this.businessShopDistributeRecordApi.searchVenueList(
  //       params,
  //       (res: any) => {
  //         console.log(res, "res");

  //         const venueList: any[] = res.data || [];

  //         this.venueList = refresh
  //           ? venueList
  //           : this.venueList.concat(venueList);

  //         if (Array.isArray(res.data) && res.data.length == 0) {
  //           this.searchVenuePageOption.isRearchBottom = true;
  //         }
  //         this.searchVenueLoading = false;

  //         this.addVenueListLoading = false;

  //         resolve();
  //       },
  //       () => {
  //         this.searchVenueLoading = false;

  //         this.addVenueListLoading = false;

  //         reject();
  //       }
  //     );
  //   });
  // }

  // // 第一次搜索 无关键字
  // private handleFirstGetVenueList() {
  //   this.searchVenueLoading = true;

  //   this.getMoreVenueList(true);
  // }

  // // 清空搜索
  // private handleClearGetVenueList() {
  //   this.remoteGetVenueQueryString = "";

  //   this.searchVenueLoading = true;

  //   this.getMoreVenueList(true);
  // }

  // // 远程搜索
  // private remoteGetVenueMethod(query: string) {
  //   query = query.trim ? query.trim() : "";

  //   if (query !== "") {
  //     this.remoteGetVenueQueryString = query;
  //     clearTimeout(this.remoteSearchVenueTimer);

  //     this.remoteSearchVenueTimer = setTimeout(() => {
  //       this.searchVenueLoading = true;

  //       this.getMoreVenueList();
        
  //     }, 300);
  //   } else {
  //     this.remoteGetVenueQueryString = "";
  //     this.venueList = [];
  //   }
  // }

  // private addVenueListLoading: boolean = false;

  // private remoteAddVenueMethod() {
  //   if (this.addVenueListLoading) return;
  //   const searchVenuePageOption = this.searchVenuePageOption;

  //   const { isRearchBottom } = searchVenuePageOption;

  //   if (isRearchBottom) return;

  //   this.searchVenuePageOption.page++;

  //   this.addVenueListLoading = true;

  //   this.getMoreVenueList(false);
  // }

  // 流水
  // private handleLimitTotalMoney(val: string) {
  //   Util.limitIntegetInput(
  //     val,
  //     (new_val: string) => {
  //       const limit_val = Math.min(Number(new_val), maxTotalMoney).toString();

  //       if (maxTotalMoney == Number(limit_val)) {
  //         this.$set(this.forms, "total_money", limit_val);
  //       } else {
  //         this.$set(this.forms, "total_money", new_val);
  //       }
  //     },
  //     (new_val: string) => {
  //       this.$set(this.forms, "total_money", new_val);
  //     }
  //   );
  // }

  // private handleLimitSingleMaxCount(val: string) {
  //   Util.limitIntegetInput(
  //     val,
  //     (new_val: string) => {
  //       this.$set(this.forms, "maxLimitCount", new_val);
  //     },
  //     (new_val: string) => {
  //       this.$set(this.forms, "maxLimitCount", new_val);
  //     }
  //   );
  // }

  private sumbitBusinessShopDistributeRecordLoading: boolean = false;

  // 提交加盟球房分布配置
  private handleSumbitBusinessShopDistributeRecord() {
    const storageLockerDialogMode = this.storageLockerDialogMode;

    const params = this.getBusinessShopDistributeRecordFormsParams(storageLockerDialogMode);

    console.log(params, "params");
    if (params === false) return;

    this.sumbitBusinessShopDistributeRecordLoading = true;
    switch (storageLockerDialogMode) {
      case "new-business-shop-distribute-record":
        this.businessShopDistributeRecordApi.addBusinessShopDistributeRecord(
          params,
          () => {
            this.getBusinessShopDistributeRecordList();
            this.dialogFormVisible = false;
            this.sumbitBusinessShopDistributeRecordLoading = false;
          },
          () => {
            this.sumbitBusinessShopDistributeRecordLoading = false;
          }
        );
        break;
      case "edit-business-shop-distribute-record":
        this.businessShopDistributeRecordApi.updateBusinessShopDistributeRecord(
          params,
          () => {
            this.getBusinessShopDistributeRecordList();
            this.dialogFormVisible = false;
            this.sumbitBusinessShopDistributeRecordLoading = false;
          },
          () => {
            this.sumbitBusinessShopDistributeRecordLoading = false;
          }
        );
        break;
    }
  }

  private getBusinessShopDistributeRecordFormsParams(mode: string) {
    const params: any = {};

    const showErrorMessage = (msg: string) => {
      if (!!msg) {
        this.$message.error(msg);
      }
    };

    const forms = this.forms;

    const {
      id,
      // name,
      // expired_days,
      // meituanId,
      // timeDuration
      // machine_number,
      // total_money,
      // remark,
      // operate_name,
      // venues,
    } = forms || {};

    // console.log(venues, 'venues')

   

    const keys = ["shop_name", "phone", "shop_status", "start_business_time", "over_contract_time", "province_id", "city_id", "region", "shop_address", "operation_manager"];

    const key2EndKey: any = {
      shop_name: "shop_name",
      phone: "phone",
      shop_status: "shop_status",
      start_business_time: "start_business_time",
      over_contract_time: "over_contract_time",
      province_id: "province_id",
      city_id: "city_id",
      
      region: "region",
      shop_address: "shop_address",
      operation_manager: "operation_manager"
    };

    const key2ErrMsg: any = {
      shop_name: "店铺名称不能为空",

      phone: "商户手机号不能为空",
      shop_status: '店铺状态不能为空',
      start_business_time: "unrequired",
      over_contract_time: "unrequired",
      province_id: "所在省份不能为空",
      city_id: "所在城市不能为空",

      region: "unrequired",
      shop_address: "unrequired",
      operation_manager: "unrequired"
    };

    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];

      if (forms[key]) {
        const errMsg = key2ErrMsg[`${key}_${forms[key]}`];
        if (errMsg) {
          showErrorMessage(errMsg);

          return false;
        }
        params[key2EndKey[key] || key] = forms[key];
      } else {
        if (key2ErrMsg[key] !== 'unrequired') {
          showErrorMessage(key2ErrMsg[key]);

          return false;
        }
      }
    }
    

    if (mode == "edit-business-shop-distribute-record") {
      params.id = id;
    }

    return params;

  }

  // private tableColDates: any[] = []

  //获取加盟球房分布列表
  private getBusinessShopDistributeRecordList(): void {
    this.businessShopDistributeRecordApi.getBusinessShopDistributeRecordList(
      { ...this.getBusinessShopDistributeRecordParams() },
      (res: any) => {
        // res.data.list
        this.tableData = res.data.list;
        this.tablePage.page = res.data.page;
        this.tablePage.prepage = res.data.prepage;
        // this.tablePage.totalPage = res.data.total;

        // this.tableColDates = res.data.day_list || [];
        this.tablePage.count = res.data.count;
      },
      () => {}
    );
  }

  private getBusinessShopDistributeRecordParams(mode = "all"): any {
    const params: any = {};

    const form = this.form;

    const tablePage = this.tablePage;

    const { page, prepage } = tablePage;

    const { shop_name, shop_status, time, city_id, contract_time } = form;

    if (shop_name) {
      params.shop_name = shop_name;
    }

    if (shop_status > -1) {
      params.shop_status = shop_status
    }

    if (city_id > -1) {
      params.city_id = city_id
    }

    if (Array.isArray(time) && time.length === 2) {
      const [startDate, endDate] = time;


      params.begin_business_time = startDate;

      params.end_business_time = endDate;
    }

    if (Array.isArray(contract_time) && contract_time.length === 2) {
      const [startDate, endDate] = contract_time;


      params.begin_contract_time = startDate;

      params.end_contract_time = endDate;
    }

     if (
      mode == "exportExcel" &&
      !(params.begin_business_time && params.end_business_time)
    ) {
      this.$message.error("请选择开业日期导出数据");
      return null;
    }



    if (mode === "all") {
      params.page = page;

      params.limit = prepage;

      // outerParams.__isUnique = !firstLoading;
    }

    return params;
  }

  private exportTable() {
    // new HealthWarning().exportTable(this.form);
  }

  /** 导出excel */
  private downloadExcelLoading: boolean = false;

  // 字段名 文案对应关系
  private merchantExcelList2ch: any = {
    shop_name: "店铺名称",
    phone: " 联系方式",
    __status_name: "店铺状态",
    start_business_time: "开业时间",
    over_contract_time: "解约时间",
    province_name: "所在省份",
    city_name: "所在城市",
    region: "所在区域",
    shop_address: "店铺位置",
    operation_manager: "运营负责人",
    opt_name: "操作人",
    opt_time: "操作时间"
  };
  // 商户Excel 表头的先后顺序
  private merchantExcelSortList: string[] = [
    "shop_name",
    "phone",
    "__status_name",
    "start_business_time",
    "over_contract_time",
    "province_name",
    "city_name",
    "region",
    "shop_address",
    "operation_manager",
    "opt_name",
    "opt_time",
  ];

  // 点击导出excel 表格
  private handleExportExcelBusinessShopDistributeRecordList() {
    const params = this.getBusinessShopDistributeRecordParams('exportExcel')

    if (params === null) {
      return false;
    }

    this.downloadExcelLoading = true;
    this.businessShopDistributeRecordApi.exportExcelBusinessShopDistributeRecordList(
      params,
      (res: any) => {
        const { begin_business_time: start_date, end_business_time: end_date, begin_contract_time, end_contract_time } = params || {};

        const businessTimeDate = start_date && end_date ? ` 开业时间：${start_date}到${end_date}` : ''

        const contractTimeDate = begin_contract_time && end_contract_time ? ` 解约时间：${begin_contract_time}到${end_contract_time}` : ''


        const filename = `加盟球房分布图列表${businessTimeDate}${contractTimeDate}.xlsx`;
        const { data } = res || {};

        const {
          list: originList
        } = data || {}

        const newList = Array.isArray(originList)
          ? originList.map((item) => {
              const { 
                // status,
                shop_status
                // back_goods_detail
               } = item || {};
              const newItem = {
                ...(item || {}),
                __status_name: shopStatus2Ch[shop_status] || '未知'
                // __status_text: withdrawAccountAudit2Text[status],
                // __back_good_details: back_goods_detail.map((goods: any, index: number) => `${ goods.name }x${ goods.num }  ¥${ goods.price }`).join('; \t')
              };

              for (let key in item) {
                if (typeof item[key] == 'number') {
                  newItem[key] = item[key].toString()
                }
              }

             
              return newItem;
            })
          : [];

        if (newList.length > 0) {
          const merchantExcelSortList = this.merchantExcelSortList;

          const merchantExcelList2ch = this.merchantExcelList2ch;

          const excelJSONData = getExcelJSONDataByList(
            newList,
            merchantExcelSortList,
            merchantExcelList2ch
          );

          excuteDownloadExport2Excel(excelJSONData, filename);
        } else {
          this.$message.info("选中时段没有可导出的信息");
        }

        this.downloadExcelLoading = false;
      },
      () => {
        this.downloadExcelLoading = false;
      }
    );
  }

  /** end 导出excel */

  private selectPage: any = {
    page: 1,
    prepage: 200,
    totalPage: 0,
    count: 0,
  };
}
